import React from 'react';
import styles from './StandardOverview.module.css';

const OverviewCardShell = ({
    title,
    headerAside,
    highlight = false,
    tall,
    compact,
    className = '',
    children,
    footer,
}) => (
    <article
        className={[
            styles.card,
            highlight === 'accent' ? styles.cardAccent : highlight ? styles.cardHighlight : '',
            tall ? styles.cardTall : '',
            compact ? styles.cardCompact : '',
            className,
        ]
            .filter(Boolean)
            .join(' ')}>
        {title ? (
            <header className={styles.cardHeader}>
                <p className={styles.cardEyebrow}>{title}</p>
                {headerAside ? <div className={styles.cardHeaderAside}>{headerAside}</div> : null}
            </header>
        ) : null}
        <div className={styles.cardBody}>{children}</div>
        {footer ? <footer className={styles.cardFooter}>{footer}</footer> : null}
    </article>
);

export const OverviewTextAction = ({ children, onClick, type = 'button' }) => (
    <button type={type} className={styles.textAction} onClick={onClick}>
        {children}
    </button>
);

export default OverviewCardShell;
